const apiURLBuilder = require('../core/apiURLBuilder');
const Api = require('../services/api');
const actionTypes = require('constants/actionTypes');
const formActions = require('react-redux-form').actions;
const suitabilityActions = require('actions/RASuitabilityTest');
const checkStatusActions = require('actions/RACheckStatus');

const resetErrors = () => {
    return {
        type: actionTypes.RA_ROBO_LOGIN_RESET_ERRORS,
        payload: '',
    };
};

const loginRoboSuccess = () => {
    return {
        type: actionTypes.RA_ROBO_LOGIN_SUCCESS,
        payload: {
            isLoggedIn: true,
        },
    };
};

const loginRoboFaliure = error => {
    return {
        type: actionTypes.RA_ROBO_LOGIN_FALIURE,
        payload: {
            error,
        },
    };
};

const login = (accessToken, loginPayload, callback) => dispatch => {
    dispatch(resetErrors());
    const request = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: loginPayload,
    };
    Api.post(apiURLBuilder.getURL('roboAuthentication'), request)
        .then(response => {
            if (response.body && response.body.otpChallenge) {
                dispatch(formActions.change('userProfile.showOTP', true));
                dispatch(formActions.change('userProfile.dataToken', response.body.dataToken));
            } else {
                callback(true);
                dispatch(loginRoboSuccess());
                dispatch(checkStatusActions.checkStatus(accessToken)).then(() =>
                    dispatch(suitabilityActions.getTestQuestions(accessToken))
                );
            }
        })
        .catch(error => {
            callback(false);
            dispatch(loginRoboFaliure(error));
        });
};

export default {
    login,
    resetErrors,
    loginRoboSuccess,
};
